import { render, staticRenderFns } from "./welcomeFinal3round2.vue?vue&type=template&id=46b1aeaf&scoped=true"
import script from "./welcomeFinal3round2.vue?vue&type=script&lang=js"
export * from "./welcomeFinal3round2.vue?vue&type=script&lang=js"
import style0 from "./welcomeFinal3round2.vue?vue&type=style&index=0&id=46b1aeaf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b1aeaf",
  null
  
)

export default component.exports